import React from 'react';
import { graphql } from 'gatsby';

import Layout from '../components/Layout';
import { AboutLinksMobile } from '../sections/InPageLinksMobile';

import Header from '../sections/Header';
import OurStory from '../sections/OurStory';
import VisionAndMission from '../sections/VisionAndMission';
import Values from '../sections/Values';
import OurPeapleCarousel from '../sections/OurPeapleCarousel';
import JoinTempo from '../sections/JoinTempo';
import { JobSection } from '../sections/CardsSections';
import { GeneralCardsSection } from '../sections/Cards';

import placeholderData from '../utils/placeholderData';

export const AboutUsTemplate = ({
  storySecName,
  storySecTitle,
  storySecContnet,
  vision,
  mission,
  peopleSecTitle,
  peopleSecSubtitle,
  joinSecTitle,
  JoinSecContent,
  blurbs,
  carouselItem,
  preview,
  JobPostsTitle = 'Jobs & volunteering at Tempo',
  getAsset,
  JoinSecSubtitle,
}) => {
  return (
    <>
      <Header page="about" title="About Tempo" />
      <AboutLinksMobile />
      <OurStory title={storySecName} subtitle={storySecTitle} description={storySecContnet} />
      <VisionAndMission title="OUR VISION" description={vision} bgcolor="midnight" />
      <VisionAndMission title="OUR MISSION" description={mission} bgcolor="blue" />
      <Values />
      <OurPeapleCarousel
        title={peopleSecTitle}
        subtitle={peopleSecSubtitle}
        data={carouselItem}
        preview={preview}
        getAsset={getAsset}
      />
      <JoinTempo
        title={joinSecTitle}
        description={JoinSecContent}
        JoinSecSubtitle={JoinSecSubtitle}
        data={blurbs}
      />
      {/* TO DO */}
      {preview ? (
        <GeneralCardsSection
          data={placeholderData}
          type="impacts"
          title={JobPostsTitle || 'Impact & updatesss'}
        />
      ) : (
        <JobSection title={JobPostsTitle} type="impacts" />
      )}
    </>
  );
};

const AboutUsPage = ({
  data: {
    markdownRemark: { frontmatter },
  },
}) => {
  const {
    storySecName,
    storySecTitle,
    storySecContnet,
    vision,
    mission,
    peopleSecTitle,
    peopleSecSubtitle,
    joinSecTitle,
    JoinSecContent,
    blurbs,
    carouselItem,
    JobPostsTitle,
    JoinSecSubtitle,
  } = frontmatter;
  return (
    <Layout>
      <AboutUsTemplate
        storySecName={storySecName}
        storySecTitle={storySecTitle}
        storySecContnet={storySecContnet}
        vision={vision}
        mission={mission}
        peopleSecTitle={peopleSecTitle}
        peopleSecSubtitle={peopleSecSubtitle}
        joinSecTitle={joinSecTitle}
        JoinSecContent={JoinSecContent}
        blurbs={blurbs}
        carouselItem={carouselItem}
        JobPostsTitle={JobPostsTitle}
        JoinSecSubtitle={JoinSecSubtitle}
      />
    </Layout>
  );
};

export const AboutUsQuery = graphql`
  query aboutUsQuery($id: String!) {
    markdownRemark(id: { eq: $id }) {
      id
      html
      frontmatter {
        storySecName
        storySecTitle
        storySecContnet
        vision
        mission
        peopleSecTitle
        peopleSecSubtitle
        joinSecTitle
        JoinSecContent
        JobPostsTitle
        JoinSecSubtitle
        carouselItem {
          item {
            text
            name
            role
            imageInfo {
              childImageSharp {
                fluid(quality: 100, maxWidth: 360) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        }
        blurbs {
          blurb
        }
      }
    }
  }
`;

export default AboutUsPage;
